import {
  BarChart,
  CheckCircle,
  Paid,
  Person,
  Phone,
  Lightbulb,
} from '@mui/icons-material'

const ActivityIcons = {
  1: Phone,
  2: BarChart,
  3: BarChart,
  4: BarChart,
  5: CheckCircle,
  6: Paid,
  7: Person,
  8: Lightbulb,
}

export default ActivityIcons
